import React, { useState, useEffect } from "react";
import Typewriter from "typewriter-effect";
import TopBtn from "../buttons/TopBtn";
import Gigantic from "../headers/Gigantic";
import Features from "./Features";
import Platforms from "./Platforms";
import Banner from "./Banner";

const Home = () => {
  return (
    // app Banner
    
      <div className="container">
        <Features />
        <Platforms />
        <TopBtn />
      </div>
  );
};

export default Home;
